import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TPeriodoEspecieVariedadCamViewModel, VariedadPeriodoPayload, VariedadPeriodoViewModel } from './periodos-variedad.types';

@Injectable()
export class PeriodosVariedadService {
    variedadPeriodoEndpoint = this.baseUrl + 'api/mantenimiento/periodos/especies/';

    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {}

    /**
     * Invokes the service to get the list of "Variedades de Periodo", applying the filter in the parameter
     * @param payload IdPeriodo number
     * @returns Observable<VariedadPeriodoViewModel>
     */
    getVariedadesDePeriodo(id: number): Observable<VariedadPeriodoViewModel[]> {
        return this.http.get<VariedadPeriodoViewModel[]>(this.variedadPeriodoEndpoint + 'ByPeriodo/' + id);
    }

    /**
     * Se envía un array con los elementos nuevos (aquellos con id a null), o aquellos marcados como deleted
     * @param variedadesDePeriodo VariedadPeriodoPayload[]
     * @returns Observable<any>
     */
    saveVariedadesDePeriodo(variedadesDePeriodo: VariedadPeriodoPayload[]): Observable<any> {
        return this.http.post<TPeriodoEspecieVariedadCamViewModel>(this.variedadPeriodoEndpoint, variedadesDePeriodo);
    }
}
